import React from 'react';
import { Clock } from 'lucide-react';
import { getTimezoneDisplayName } from '../../lib/formatUtils';

interface TimezoneIndicatorProps {
  className?: string;
}

export const TimezoneIndicator: React.FC<TimezoneIndicatorProps> = ({ className = '' }) => {
  const timezone = getTimezoneDisplayName();
  
  return (
    <div className={`flex items-center gap-2 text-xs text-gray-500 ${className}`}>
      <Clock className="h-3 w-3" />
      <span>Times displayed in {timezone}</span>
    </div>
  );
};
